import { SideNav } from "components";
import React from "react";
import { Ptag } from "components/core";
import { DashboardWrapper, Header } from "pages/MainDashboard/styles";
import TextInline from "pages/ClaimSupport/TextInline";
import { WidthLimiter } from "pages/PlanSetup/styles";
import styled from "styled-components";
import { useNavigate } from "react-router";
import routes from "components/routes";

const name = localStorage.getItem("name");
const email = localStorage.getItem("email");

function UserProfile() {
  const navigate = useNavigate();
  const redirectToChangePassword = () => {
    navigate(`/${routes.CHANGE_PASSWORD}`);
  };
  return (
    <>
      <SideNav />
      <DashboardWrapper>
        <Header>
          <Ptag
            fontSize="26px"
            letterHeight="44px"
            fontWeight="600"
            fontFamily="Merriweather"
          >
            {name ? `Hello ${name}` : "Welcome to Vital"}
          </Ptag>
        </Header>
        <div style={{ marginTop: "4rem" }}>
          <WidthLimiter>
            <Ptag
              fontSize="24px"
              fontWeight="700"
              style={{ paddingBottom: "36px" }}
            >
              My Profile
            </Ptag>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "2rem" }}
            >
              <TextInline name={name} label={"Name"} height={"52px"} />
              <TextInline name={email} label={"Email"} height={"52px"} />
              <ChangePasswordButton onClick={() => redirectToChangePassword()}>
                Change Password
              </ChangePasswordButton>
            </div>
          </WidthLimiter>
        </div>
      </DashboardWrapper>
    </>
  );
}

export default UserProfile;

const ChangePasswordButton = styled.div`
  border: 1px solid rgb(35, 26, 61);
  padding: 14px 24px;
  color: rgb(35, 26, 61);
  background-color: transparent;
  border-radius: 7px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 2rem;
  font-family: "Inter";
  font-weight: 500;
  width: fit-content;
`;
